<div class="qa-overlay" (click)="fermer.emit()">
  <div
    class="qa-modal"
    [class.qa-modal--petite]="etape === 'confirmation'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="qa-titre"
    (click)="$event.stopPropagation()"
  >
    <header class="qa-header">
      <div>
        <h2 id="qa-titre" class="qa-titre">QR code de l'atelier</h2>
        <p class="qa-sous-titre">
          {{
            etape === "confirmation"
              ? (activite?.nomActivity | titlecase)
              : "Prêt à imprimer ou à projeter le jour de l'atelier"
          }}
        </p>
      </div>
      <button
        type="button"
        class="qa-fermer"
        aria-label="Fermer"
        (click)="fermer.emit()"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          aria-hidden="true"
        >
          <path d="M6 6l12 12M18 6L6 18" />
        </svg>
      </button>
    </header>

    <!-- ===== Étape 1 : confirmation (même message que l'ancienne popup) ===== -->
    <div *ngIf="etape === 'confirmation'" class="qa-confirmation">
      <span class="qa-confirmation__icone" aria-hidden="true">
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3" />
        </svg>
      </span>
      <p class="qa-confirmation__texte">
        Le QR code de l'activité
        <strong>{{ activite?.nomActivity | titlecase }}</strong>
        va être généré et pourra être utilisé pour la validation de présence.
        Continuer l'opération ?
      </p>
      <div class="qa-confirmation__actions">
        <button
          type="button"
          class="qa-btn qa-btn--secondaire"
          (click)="fermer.emit()"
        >
          Annuler
        </button>
        <button
          type="button"
          class="qa-btn qa-btn--primaire"
          (click)="generer()"
        >
          Générer
        </button>
      </div>
    </div>

    <!-- ===== Étape 2 : affiche ===== -->
    <div *ngIf="etape === 'affiche'" class="qa-corps">
      <!-- Aperçu : c'est exactement l'image imprimée / téléchargée -->
      <div class="qa-apercu" [class.qa-apercu--qr]="format === 'qr'">
        <p *ngIf="chargement && !erreur" class="qa-etat">
          Génération du QR code…
        </p>
        <div *ngIf="erreur" class="qa-etat qa-etat--erreur">
          <p>Impossible de générer le QR code.</p>
          <button
            type="button"
            class="qa-btn qa-btn--secondaire qa-reessayer"
            (click)="generer()"
          >
            Réessayer
          </button>
        </div>
        <img
          *ngIf="apercuUrl && !erreur"
          [src]="apercuUrl"
          [alt]="'QR code de ' + (activite?.nomActivity ?? 'l\'atelier')"
        />
      </div>

      <aside class="qa-cote">
        <h3 class="qa-cote__titre">
          {{ format === "affiche" ? "Affiche de l'atelier" : "QR code seul" }}
        </h3>
        <p class="qa-cote__texte">
          {{
            format === "affiche"
              ? "Affiche A4 avec le nom de l'atelier, la date, l'heure et le lieu, prête à imprimer, télécharger ou projeter."
              : "L'image du QR code seule, à insérer dans un support de votre choix."
          }}
        </p>

        <div class="qa-bloc">
          <span id="qa-format" class="qa-label">Format</span>
          <div class="qa-segment" role="group" aria-labelledby="qa-format">
            <button
              type="button"
              [class.is-active]="format === 'affiche'"
              [attr.aria-pressed]="format === 'affiche'"
              (click)="choisirFormat('affiche')"
            >
              Affiche A4
            </button>
            <button
              type="button"
              [class.is-active]="format === 'qr'"
              [attr.aria-pressed]="format === 'qr'"
              (click)="choisirFormat('qr')"
            >
              QR seul
            </button>
          </div>
        </div>

        <div class="qa-espace"></div>

        <button
          type="button"
          class="qa-btn qa-btn--primaire"
          [disabled]="!apercuUrl"
          (click)="imprimer()"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M6 9V3h12v6" />
            <rect x="3" y="9" width="18" height="8" rx="2" />
            <path d="M6 14h12v7H6z" />
          </svg>
          Imprimer
        </button>
        <button
          type="button"
          class="qa-btn qa-btn--secondaire"
          [disabled]="!apercuUrl"
          (click)="telecharger()"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
          </svg>
          Télécharger (PNG)
        </button>
        <button
          type="button"
          class="qa-btn qa-btn--secondaire"
          (click)="fermer.emit()"
        >
          Fermer
        </button>
      </aside>
    </div>
  </div>
</div>
